import { Box } from '@mui/material';
import SearchField from 'components/controls/SearchField';
import { func, object, string } from 'prop-types';
import React from 'react';

const Search = rawProps => {
  const props = { value: '', ...rawProps };
  const { value, onChange, inputProps } = props;
  return (
    <Box
      sx={{
        minWidth: 200,
        flex: '1 0 auto',
        display: 'flex',
        alignItems: 'center',
        mr: '10px',
      }}
    >
      <SearchField value={value} onChange={onChange} inputProps={inputProps} />
    </Box>
  );
};

Search.propTypes = {
  value: string,
  onChange: func.isRequired,
  inputProps: object,
};

export default Search;
